import React from 'react';
import { cn } from '@/lib/utils';
import { statusConfig, colorStyles, badgeBase } from './MappingStatusBadge.styles';
import type { MappingStatusBadgeProps } from './MappingStatusBadge.types';

export const MappingStatusBadge: React.FC<MappingStatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status] || statusConfig.pending;
  const colorClass = colorStyles[config.color] ?? colorStyles.amber;

  return (
    <span
      data-testid={`mapping-status-${status}`}
      className={cn(badgeBase, colorClass)}
    >
      {config.label}
    </span>
  );
};
